<style lang="less" scoped src="../css/common.less"></style>
<style scoped>

</style>
<template>
    <div class="wrap">
        <h2 class="text-center">发票详情</h2>
        <div v-if="invoice.id">
            <div class="line">
                <div class="label">发票代码</div>
                <div class="value">{{invoice.code || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">发票号码</div>
                <div class="value">{{invoice.uid || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">发票类型</div>
                <div class="value">{{invoice_type}}</div>
            </div>
            <div class="line">
                <div class="label">发票金额</div>
                <div class="value">{{total_price}}</div>
            </div>
            <div class="line">
                <div class="label">发票税前金额</div>
                <div class="value">{{this.$util.formatPrice(invoice.pretax_price)}}</div>
            </div>
            <div class="line">
                <div class="label">发票税额</div>
                <div class="value">{{this.$util.formatPrice(invoice.tax)}}</div>
            </div>
            <div class="line">
                <div class="label">综合税率(%)</div>
                <div class="value">{{tax_rate}}</div>
            </div>
            <div class="line">
                <div class="label">开票时间</div>
                <div class="value">{{invoice.invoice_date || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">认证月份</div>
                <div class="value">{{invoice.use_month || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">发票文件</div>
                <div class="value">
                    <InvoicePicture :invoice_id="invoice.id" v-if="invoice.invoice_file_id"></InvoicePicture>
                    <span v-else>-</span>
                </div>
            </div>
            <div class="line">
                <div class="label">校验码</div>
                <div class="value">{{invoice.check_code || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">销售方</div>
                <div class="value">{{invoice.seller || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">购买方</div>
                <div class="value">{{invoice.buyer || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">验真状态</div>
                <div class="value">{{invoice.validation}}</div>
            </div>
            <div class="line">
                <div class="label">备注</div>
                <div class="value">{{invoice.remark || '-'}}</div>
            </div>
            <div class="hr"></div>
            <div class="line">
                <div class="label">相关付款/报销</div>
                <div class="value">
                    <div v-if="invoice.expense_groups && invoice.expense_groups.length">
                        <div class="line" v-for="expense_group in invoice.expense_groups" :key="expense_group.id">
                            <ViewerItem :model_id="expense_group.id" type="ExpenseGroup">
                                <span class="link">{{expense_group.uid}}</span>
                            </ViewerItem>
                            <span>{{expense_group.name}}</span>
                        </div>
                    </div>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="line">
                <div class="label">相关合同</div>
                <div class="value">
                    <div v-if="invoice.contracts && invoice.contracts.length">
                        <div class="line" v-for="contract in invoice.contracts" :key="contract.id">
                            <ViewerItem :model_id="contract.id" type="Contract">
                                <span class="link">{{contract.uid}}</span>
                            </ViewerItem>
                            <span>{{contract.name}}</span>
                        </div>
                    </div>
                    <div v-else>-</div>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="loading">
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import InvoiceUtil from '../../../../libs/invoice_util';
    import InvoicePicture from '../../../invoice/components/invoice_picture';
    import ViewerItem from '../item';
    export default {
        components: { ViewerItem, InvoicePicture },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                invoice: {},
                loading: false
            }
        },
        computed: {
            invoice_type(){
                return InvoiceUtil.invoiceType(this.invoice.invoice_type);
            },
            total_price(){
                return Util.formatPrice(this.invoice.total_price);
            },
            tax_rate(){
                return Util.formatPrice(this.invoice.tax_rate);
            }
        },
        created(){
            this.getInvoice();
        },
        mounted(){
            //
        },
        methods: {
            getInvoice(){
                this.loading = true;
                Util.ajax.get(Util.api.invoice_detail, {
                    params: {
                        id: this.model_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        this.invoice = res.data.invoice;
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            }
        }
    }
</script>
